/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type CreateSocialNetworkDtoPlatform = typeof CreateSocialNetworkDtoPlatform[keyof typeof CreateSocialNetworkDtoPlatform];


export const CreateSocialNetworkDtoPlatform = {
  telegram: 'telegram',
  bale: 'bale',
  whatsapp: 'whatsapp',
  eitaa: 'eitaa',
  instagram: 'instagram',
  rubika: 'rubika',
} as const;
